<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Ảnh
        </label>
        <b-form-file ref="fileInput" v-model="file" accept="image/jpeg, image/png, image/gif, image/jpg, image/webp"></b-form-file>
        <p v-if="error"  class="text-red-700 font-semibold">Lỗi: {{error}}</p>
        <div class="mt-2 relative" v-if="entry.image">
            <img class="object-cover w-full cursor-pointer rounded-lg min-h-[200px]" :src="$addPrefix(entry.image)" v-viewer alt @error="replaceBrokenImage">
            <div @click="deleteImage" class="flex p-1 bg-white rounded-full absolute top-2 left-2 cursor-pointer">
                <i class='bx bx-x' ></i>
            </div>
        </div>
    </b-form-group>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            image: "",
        },
        file: null,
        response: null,
        error: null,
    }),
    methods: {
        ...mapActions('upload', ['UploadSingleFile']),
        async uploadFile() {
            const file = this.$refs.fileInput.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const response = await this.UploadSingleFile(formData)
            if (response.code == 200) {
                this.error = null
                this.entry.image = response.url
            } else {
                this.error = response.message
                this.entry.image = null
            }
        },
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/error/no-image.png");
		},
        deleteImage() {
            this.$refs['fileInput'].reset()
            this.error = null
            this.entry.image = null
        }
    },
    watch: {
        "file": {
            handler: function () {
                if (this.file.name) {
                    this.uploadFile()
                }
            },
            deep: true,
        },
        "entry.image": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    image: this.entry.image,
                });
            },
            deep: true,
        },
        "value.image": {
            handler: function () {
                this.entry.image = this.value.image;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>